import { Record, Map } from 'immutable'

export const MAX_FILE_SIZE = 200 * 1024 * 1024 /* 200MB */
export const MAX_IMAGE_SIZE = 5 * 1024 * 1024 /* 5MB */
export const FREE_MAX_FILE_SIZE = 10 * 1024 * 1024 /* 10MB */

// Accept all file types since checking mime types or extensions doesnt provide security
export const FILE_ACCEPTED_TYPES = null
export const IMAGE_ACCEPTED_TYPES = 'image/*'

export const FileUploadRecord = Record(
  {
    uuid: null,
    url: null,
    mediaMeta: null,
    error: null,
    uploading: null,
    meta: Map(),
  },
  'fileUpload'
)
